import React from 'react';
import { connect } from 'react-redux';
import { getFormIoFormId } from '../DriverReportForm/redux-objects/actions';
import Form from '../../FormIO/presentation/FormWithValidations';

interface Props {
  getFormIoFormId: () => void;
  driverReportFormIoFormId: string;
}

class GenericDriverReportForm extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  componentDidMount(): void {
    const { driverReportFormIoFormId, getFormIoFormId } = this.props;
    if (!driverReportFormIoFormId) getFormIoFormId();
  }

  render() {
    const { driverReportFormIoFormId } = this.props;

    return driverReportFormIoFormId && (
      <Form formId={driverReportFormIoFormId} />
    )
  }
}

const mapDispatchToProps = {
  getFormIoFormId,
};

const mapStateToProps = (reduxState: any) => {
  return {
    driverReportFormIoFormId: reduxState.DriverReportForm.DriverReportFormIoFormId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericDriverReportForm);